(function () {
  function isCroatianRoot() {
    var host = window.location.hostname;
    var path = window.location.pathname || '';

    if (host !== '0-signature.com') return false;
    if (path === '/en' || path.indexOf('/en/') === 0) return false;

    return true;
  }

  function translateSizeLegend() {
    if (!isCroatianRoot()) return;

    var legends = document.querySelectorAll('legend');

    legends.forEach(function (legend) {
      var text = (legend.textContent || '').trim();

      if (text === 'Size:' || text === 'Size') {
        legend.textContent = 'Veličina:';
      }
    });
  }

  function init() {
    if (!isCroatianRoot()) return;

    translateSizeLegend();

    var observer = new MutationObserver(function (mutations) {
      var shouldRun = false;

      for (var i = 0; i < mutations.length; i++) {
        var mutation = mutations[i];

        if (mutation.addedNodes && mutation.addedNodes.length) {
          for (var j = 0; j < mutation.addedNodes.length; j++) {
            var node = mutation.addedNodes[j];

            if (node.nodeType !== 1) continue;

            if (
              node.tagName === 'LEGEND' ||
              (node.querySelector && node.querySelector('legend'))
            ) {
              shouldRun = true;
              break;
            }
          }
        }

        if (shouldRun) break;
      }

      if (shouldRun) {
        translateSizeLegend();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
